import React, { useState, useRef } from "react";
import "./order.css";
import axios from "axios";
import { Link } from "react-router-dom";
import { useContext } from "react";
import {
  totalContext,
  useCardItems,
  usePassOrder,
} from "../context/cardContext";
import { useEmptyBasket } from "../context/basketContext";
function OrderInfo() {
  const price = useContext(totalContext);
  const achats = useCardItems();
  const emptyBasket = usePassOrder();
  const empty = useEmptyBasket();
  const region = useRef();
  const lastName = useRef();
  const firstName = useRef();
  const email = useRef();
  const number = useRef();
  const city = useRef();
  const adress = useRef();
  const [load, setLoad] = useState(false);
  const [sent, setSent] = useState(false);
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [emaill, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [regionn, setRegion] = useState("");
  const [cityy, setCity] = useState("");
  const [adresss, setAdress] = useState("");
  const [validation, setValidation] = useState("");
  const validate = async () => {
    if (
      lastName.current.value === "" ||
      firstName.current.value === "" ||
      email.current.value === "" ||
      number.current.value === "" ||
      region.current.value === "" ||
      city.current.value === "" ||
      adress.current.value === ""
    ) {
      setValidation("Please fill all the fields !");
      return;
    } else if (
      lastName.current.value.length < 3 ||
      firstName.current.value.length < 3 ||
     
      region.current.value.length < 3 ||
      city.current.value.length < 3 ||
      adress.current.value.length < 3
    ) {
      setValidation("Please fill the fields with valid inputs !");
      return;
    }else if (
      number.current.value.length !== 8 
      
    ) {
      setValidation("Please enter a valid phone number !");
      return;
    }  else if (
      !email.current.value.includes("@") ||  !email.current.value.includes(".") ||  email.current.value.length < 6 
    ) {
      setValidation("Please enter a valid email !");
      return;
    }
    setLoad(true);
    const url = process.env.REACT_APP_BACKEND_URL + "shop/createOrder";
    const products = [];
    achats.map((e) => products.push(e._id));
    console.log(products.toString());
    try {
      const resp = await axios.post(url, {
        prenom: firstName.current.value,
        nom: lastName.current.value,
        phone: number.current.value,
        email: email.current.value,
        achats: products,
        amount: price + 6,
        region: region.current.value,
        city: city.current.value,
        adress: adress.current.value,
      });
      //window.location.replace("http://localhost:3000/shop");
      console.log("this is the result" + resp.data);
      setNom("");
      setPrenom("");
      setEmail("");
      setPhone("");
      setRegion("");
      setCity("");
      setAdress("");
      setSent(true);
      emptyBasket();
      empty();
    } catch (e) {
      console.log(e);
    }
    setLoad(false);
  };
  return (
    <div className="orderInfo">
      <div className="titleBetweenLines">
        <div className="lineOne"></div>
        <div className="middleTitle">Validate the Order</div>
        <div className="lineOne"></div>
      </div>
      <div className="addressPart">
        <div className="adressTitle">Personal informations</div>
        <div className="sepVertLine"> </div>
        <div className="orderBlocAdresse">
          <div className="orderLabel">First name * : </div>
          <input
            min="3"
            required
            value={prenom}
            onChange={(e) => {
              setPrenom(e.target.value);
            }}
            ref={firstName}
            type="text"
            placeholder="Enter your first name...."
            className="inputRegion"
          />
          <div className="orderLabel">Last name * : </div>
          <input
            required
            min="3"
            value={nom}
            onChange={(e) => {
              setNom(e.target.value);
            }}
            ref={lastName}
            type="text"
            placeholder="Enter your last name ...."
            className="inputRegion"
          />
          <div className="orderLabel">Email * : </div>
          <input
            min="6"
            required
            ref={email}
            value={emaill}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            type="email"
            placeholder="Enter your email ...."
            className="inputRegion"
          />
          <div className="orderLabel">Phone number * : </div>
          <input
            size="8"
            required
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
            ref={number}
            type="number"
            placeholder="Enter your phone number ...."
            className="inputRegion"
          />
        </div>
      </div>
      <div className="addressPart">
        <div className="adressTitle">Adress Informations</div>
        <div className="sepVertLine"> </div>
        <div className="orderBlocAdresse">
          <div className="orderLabel">Region * : </div>
          <input
            min="3"
            required
            value={regionn}
            onChange={(e) => {
              setRegion(e.target.value);
            }}
            ref={region}
            type="text"
            placeholder="Bizerte / Sfax / Le Kef / Jendouba / Sousse / Tunis ...."
            className="inputRegion"
          />
          <div className="orderLabel">City * : </div>
          <input
            min="3"
            required
            ref={city}
            value={cityy}
            onChange={(e) => {
              setCity(e.target.value);
            }}
            type="text"
            placeholder="Enter your current city ...."
            className="inputRegion"
          />
          <div className="orderLabel">Adress * : </div>
          <input
            required
            min="3"
            ref={adress}
            value={adresss}
            onChange={(e) => {
              setAdress(e.target.value);
            }}
            type="text"
            placeholder="Road / Apartment / Building / Suite / Bloc ..."
            className="inputRegion"
          />
        </div>
      </div>

      {load ? (
        <div className="spinner-border text-dark" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <div className="endOrder" onClick={validate}>
          Validate
        </div>
      )}
      {sent ? (
        <div className="fillScreen">
          <div className="ordersent">
            <p className="confirmText">
              Your order has been sent successfully ✔ <br />
              <br /> We will contact you as soon as possible to confirm with you
            </p>
            <Link to="/shop" className="okayOrder">
              Okay
            </Link>
          </div>
        </div>
      ) : (
        <div></div>
      )}
      {validation!=="" ? (
        <div className="fillScreen">
          <div className="ordersent">
            <p className="confirmText">
              Error occured 😥 <br />
              <br /> {validation}
            </p>
            <div onClick={()=>{setValidation("")}} className="okayOrder">
              Okay
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default OrderInfo;
